import { useState, useMemo } from "react";

const useCoursesFilter = () => {
  const [topic, setTopic] = useState("");
  const [level, setLevel] = useState("");
  const [search, setSearch] = useState("");

  const topicFilter = useMemo(() => {
    return topic ? `filters[topic]=${topic}` : "";
  }, [topic]);

  const levelFilter = useMemo(() => {
    return level ? `filters[level]=${level}` : "";
  }, [level]);

  const searchFilter = useMemo(() => {
    return search ? `filters[keyword]=${search}` : "";
  }, [search]);

  const queryParams = useMemo(() => {
    const params = [topicFilter, levelFilter, searchFilter].filter(Boolean).join("&");
    return params ? `${params}` : "";
  }, [topicFilter, levelFilter, searchFilter]);

  return [queryParams, setTopic, setLevel, setSearch, topic, level];
};

export default useCoursesFilter;
